var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useMemo } from 'react';
import { Box, Checkbox, CircularProgress, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { baseColors } from '../../Themes/colors';
import CustomButton from '../../components/buttonComponent/CustomButton';
import { FilterPanelWrapper, FilterHeader, FilterBody, FilterFooter, FilterFooterActions, } from './filterStyles';
var ColumnSettings = function (_a) {
    var allColumns = _a.allColumns, visibleColumnKeys = _a.visibleColumnKeys, onSave = _a.onSave, onCancel = _a.onCancel, onReset = _a.onReset, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var _c = useState(visibleColumnKeys), draftVisibleKeys = _c[0], setDraftVisibleKeys = _c[1];
    var _d = useState(''), searchText = _d[0], setSearchText = _d[1];
    var filteredColumns = useMemo(function () {
        if (!searchText.trim())
            return allColumns;
        var lower = searchText.toLowerCase();
        return allColumns.filter(function (col) { return col.header.toLowerCase().includes(lower); });
    }, [allColumns, searchText]);
    var handleToggle = function (key) {
        setDraftVisibleKeys(function (prev) {
            return prev.includes(key) ? prev.filter(function (k) { return k !== key; }) : __spreadArray(__spreadArray([], prev, true), [key], false);
        });
    };
    var handleReset = function () {
        onReset();
    };
    React.useEffect(function () {
        setDraftVisibleKeys(visibleColumnKeys);
    }, [visibleColumnKeys]);
    return (React.createElement(FilterPanelWrapper, { sx: { height: '100%', minHeight: 0 } },
        React.createElement(FilterHeader, null,
            React.createElement(Typography, { variant: 'h6' }, "Column Settings"),
            React.createElement(Stack, { direction: "row", sx: {
                    gap: '6px',
                    alignItems: 'center',
                    color: loading ? baseColors.greyPreset[20] : baseColors.successPreset[30],
                    cursor: loading ? 'default' : 'pointer',
                    fontSize: 13,
                    pointerEvents: loading ? 'none' : 'auto',
                }, onClick: loading ? undefined : handleReset },
                React.createElement("span", { className: "icon-Reload" }),
                React.createElement(Typography, { variant: "subtitle2" }, "Reset"))),
        React.createElement(FilterBody, { sx: { height: 'auto', minHeight: 0, flex: '1 1 auto' } }, loading ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { flex: 1, gap: 1.5, py: 4 } },
            React.createElement(CircularProgress, { size: 24, sx: { color: baseColors.successPreset[30] } }),
            React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[20] }, "Loading columns..."))) : (React.createElement(React.Fragment, null,
            React.createElement(TextField, { fullWidth: true, size: "small", placeholder: "Search Column", value: searchText, onChange: function (e) { return setSearchText(e.target.value); }, InputProps: {
                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                        React.createElement("span", { className: "icon-Research", style: { fontSize: 14, color: baseColors.greyPreset[10] } }))),
                }, sx: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                        fontSize: 13,
                        '& fieldset': { borderColor: baseColors.greyPreset[40] },
                    },
                } }),
            React.createElement(Box, null,
                filteredColumns.length === 0 && (React.createElement(Typography, { variant: "body2", sx: { color: baseColors.greyPreset[20], textAlign: 'center', py: 2, fontSize: 13 } }, "No Columns Available")),
                filteredColumns.map(function (col) { return (React.createElement(Stack, { key: col.key, direction: "row", alignItems: "center", sx: {
                        px: 1,
                        py: 0.5,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: baseColors.greyPreset[55] },
                        borderRadius: 1,
                    }, onClick: function () { return handleToggle(col.key); } },
                    React.createElement(Checkbox, { checked: draftVisibleKeys.includes(col.key), size: "small", sx: {
                            color: baseColors.greyPreset[20],
                            '&.Mui-checked': { color: baseColors.successPreset[30] },
                            p: 0.5,
                        } }),
                    React.createElement(Typography, { variant: "body2", fontWeight: 500, sx: { ml: 1, textTransform: 'uppercase', fontSize: 13 } }, col.header))); }))))),
        React.createElement(FilterFooter, null,
            React.createElement(FilterFooterActions, null,
                React.createElement(CustomButton, { variant: "contained", onClick: function () { return onSave(draftVisibleKeys); }, disabled: loading, fullWidth: true, SMButton: true }, "Apply"),
                React.createElement(CustomButton, { variant: "secondary", onClick: onCancel, fullWidth: true, SMButton: true }, "Cancel")))));
};
export default ColumnSettings;
